import { IApplicationState } from '../../types/redux';

export const selectIsMyHomePage = (state: IApplicationState) => {
  return state.myHome.isMyHomePage;
};
